import { RootLayout } from "layouts";
import * as Pages from "pages";
import {
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements
} from "react-router-dom";

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />}>
            <Route index element={<Pages.Dashboard />} />
            <Route path="login" element={<Pages.Login />} />

            <Route path="incidents">
                <Route index element={<Pages.Incidents />} />
                <Route path="view/:id" element={<Pages.Incident />} />
            </Route>

            <Route path="communities">
                <Route index element={<Pages.Communities />} />
                <Route path="delete" element={<Pages.DeleteCommunities />} />
                <Route path="block" element={<Pages.BlockedCommunities />} />
                <Route path="view/:id">
                    <Route index element={<Pages.Community />} />
                    <Route path="members" element={<Pages.Members />} />
                </Route>
            </Route>

            <Route path="users">
                <Route index element={<Pages.Users />} />
                <Route path="delete" element={<Pages.DeleteUsers />} />
                <Route path="block" element={<Pages.BlockedUsers />} />
                <Route path="online" element={<Pages.OnlineUsers />} />
                <Route path="view/:id">
                    <Route index element={<Pages.Profile />} />
                    <Route path="followers" element={<Pages.Followers />} />
                    <Route path="following" element={<Pages.Following />} />
                </Route>
            </Route>

            <Route path="hashtags">
                <Route index element={<Pages.Hashtags />} />
                <Route path="view/:id" element={<Pages.HashtagDetails />}>
                    <Route index element={<Pages.HashtagTable />} />
                    <Route path="posts" element={<Pages.HashtagPosts />} />
                </Route>
            </Route>

            <Route path="notifications">
                <Route index element={<Pages.Notifications />} />
                <Route path="create" element={<Pages.CreateNotifications />} />
                <Route
                    path="view/:id"
                    element={<Pages.NotificationDetails />}
                />
            </Route>

            <Route path="report-posts">
                <Route index element={<Pages.PostsReports />} />
                <Route path="spam" element={<Pages.SpamReports />} />
                <Route path="sexual" element={<Pages.SexualReports />} />
                <Route
                    path="copyrights"
                    element={<Pages.CopyrightsReports />}
                />
                <Route
                    path="anti-social"
                    element={<Pages.AntiSocialReports />}
                />
                <Route path="illegal" element={<Pages.IllegalReports />} />
                <Route path="others" element={<Pages.OtherReports />} />
            </Route>
            <Route path="spam-posts" element={<Pages.SpamPosts />} />
            <Route path="post/:id" element={<Pages.PostPage />} />
            <Route path="activity" element={<Pages.Activities />} />
            <Route path="calendar" element={<Pages.Calendar />} />
            <Route path="log-report" element={<Pages.LogReport />} />
        </Route>
    )
);
function App() {
    return <RouterProvider router={router} />;
}

export default App;
